<template>
    <div class="userDatatable-content">
        <form @submit.prevent="submit">
            <div class="card-body">
                <div class="form-group mb-25">
                    <label for="name">Nama Provider</label>
                    <input type="text" class="form-control" id="name" v-model="form.name" required>
                </div>
                <div class="form-group mb-25">
                    <label for="model">Model AI</label>
                    <input type="text" class="form-control" id="model" v-model="form.model" placeholder="gpt-4o, gemini-pro, claude-3" required>
                </div>
                <div class="form-group mb-25">
                    <label for="base_url">Base URL</label>
                    <input type="text" class="form-control" id="base_url" v-model="form.base_url" placeholder="https://api.openai.com/v1" required>
                </div>
                <div class="form-group mb-25">
                    <label for="api_key">API Key</label>
                    <input type="text" class="form-control" id="api_key" v-model="form.api_key" required>
                </div>
                <div class="form-group mb-25">
                    <label for="priority">Prioritas (Makin kecil makin prioritas)</label>
                    <input type="number" class="form-control" id="priority" v-model.number="form.priority" required>
                </div>
                <div class="form-group mb-25">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="edit_is_active" v-model="form.is_active">
                        <label class="custom-control-label" for="edit_is_active">Aktif</label>
                    </div>
                </div>
                <div class="form-group mb-25">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="edit_file_support" v-model="form.file_support">
                        <label class="custom-control-label" for="edit_file_support">File/Vision Support</label>
                    </div>
                </div>
                 <div class="d-flex justify-content-end">
                    <button type="submit" class="btn btn-primary btn-default btn-squared text-capitalize text-white">
                        Simpan Perubahan
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: {
            selectedProvider: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                form: {
                    id: null,
                    name: "",
                    model: "",
                    base_url: "",
                    api_key: "",
                    priority: 0,
                    is_active: true,
                    file_support: false,
                },
            };
        },
        watch: {
            selectedProvider: {
                immediate: true,
                handler(val) {
                    if (val) {
                        this.form = { ...val };
                    }
                },
            },
        },
        methods: {
            async submit() {
                try {
                    await this.$store.dispatch("chatgpt_update_provider", this.form);
                    this.$toast.success("Provider berhasil diperbarui");
                     this.$root.$emit("refresh_provider_table");
                    this.$modal.hide("edit_provider");
                } catch (error) {
                    this.$toast.error("Gagal memperbarui provider");
                }
            },
        },
    };
</script>
